import { Map, List } from 'immutable';
import quickBetReducer from './quickBetReducer.js';
import betSlipsReducer from './betSlipsReducer.js';
import betTypesReducer from './betTypesReducer.js';
import couponAmountReducer from './couponAmountReducer.js';
import selectedBetType from './selectedBetTypeReducer.js';
import couponStatusReducer from './couponStatusReducer.js';
import * as BetStatus from '../../constants/BetStatus.js';
import * as BetType from '../../constants/BetType.js';
import * as Actions from '../../actions/coupon/coupon';
var initialState = Map({
    quickBet: new Map({
        bet: new Map(),
        loading: false,
        status: BetStatus.INIT,
        resolution: undefined,
        stakeTime: undefined,
        betCreateError: undefined,
        limit: undefined
    }),
    betSlips: Map(),
    persistedBetType: undefined,
    betTypes: new List(),
    couponAmount: '',
    selectedBetType: {
        betType: BetType.SINGLE,
        rank: null
    },
    couponStatus: new Map({
        bets: new Map(),
        loading: false,
        status: BetStatus.INIT,
        delay: undefined,
        resolution: undefined,
        stakeTime: undefined,
    })
});
export default function couponReducer(coupon, action) {
    if (coupon === void 0) { coupon = initialState; }
    switch (action.type) {
        case Actions.SAVE_BET_TYPE:
            if (action.data === undefined) {
                coupon = coupon.update('persistedBetType', function () { return undefined; });
            }
            else {
                coupon = coupon.update('persistedBetType', function () { return action.data; });
            }
            break;
        case Actions.CLEAR_BETSLIPS:
            coupon = coupon.update('persistedBetType', function () { return undefined; });
            break;
        case Actions.DELETE_BETSLIP:
            coupon = coupon.update('couponStatus', function (bt) { return deleteBetSlip(bt); });
            break;
    }
    coupon = coupon.update('quickBet', function (bs) { return quickBetReducer(bs, action); });
    coupon = coupon.update('betSlips', function (bs) { return betSlipsReducer(bs, action); });
    coupon = coupon.update('couponAmount', function (ca) { return couponAmountReducer(ca, action); });
    coupon = coupon.update('betTypes', function (bt) { return betTypesReducer(bt, coupon.get('betSlips'), action); });
    coupon = coupon.update('selectedBetType', function (bt) { return selectedBetType(bt, action); });
    coupon = coupon.update('couponStatus', function (bt) { return couponStatusReducer(bt, action); });
    if (Array.isArray(action.data)) {
        var isAlternativeStakeError = action.data.some(function (item) { return item.Error === -18; });
        if (isAlternativeStakeError) {
            coupon = coupon.set("couponAmount", "");
            localStorage.removeItem("couponAmountValue");
        }
        return coupon;
    }
    if ((action.data || {}).Error === -18) {
        coupon = coupon.set("couponAmount", "");
        localStorage.removeItem("couponAmountValue");
        return coupon;
    }
    return coupon;
}
function deleteBetSlip(bt) {
    return bt = bt.update('bets', function () { return new Map(); });
}



// WEBPACK FOOTER //
// ./src/reducers/coupon/couponReducer.js